import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import clsx from 'clsx';
import React from 'react';

import Copyright from '../../components/Copyright';
import DrawerMenu from '../../components/DrawerMenu';
import TopBar from '../../components/TopBar';
import useStyles from '../../useStyles';
import ARPPU from './components/ARPPU';
import ARPPUWeek from './components/ARPPUWeek';
import Attendance from './components/Attendance';
import AttendanceWeek from './components/AttendanceWeek';
import NOCReason from './components/NOCReason';
import PA from './components/PA';
import PAWeek from './components/PAWeek';
import ProductReason from './components/ProductReason';
import Revenue from './components/Revenue';
import RevenueWeek from './components/RevenueWeek';
import RevPerSeller from './components/RevPerSeller';
import RevPerSellerWeek from './components/RevPerSellerWeek';
import Team from './components/Team';
import TodayInfo from './components/TodayInfo';




export default function StoreInfo(props) {
  const classes = useStyles();

  const store_list = JSON.parse(sessionStorage.getItem('stores'));
  sessionStorage.setItem('store_id',store_list[0].id);
  sessionStorage.setItem('store_name',store_list[0].store_name);
  
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  return (
    <div className={classes.root}>
      <CssBaseline />
      <TopBar />
      <DrawerMenu />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <TodayInfo classes={classes} store_id={sessionStorage.store_id}/>

            <Grid item xs={12} md={4} lg={4}>
              <Paper className={fixedHeightPaper}>
                  <NOCReason store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>

            <Grid item xs={12} md={4} lg={4}>
              <Paper className={fixedHeightPaper}>
                  <ProductReason store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>

            <Grid item xs={12} md={4} lg={4}>
              <Paper className={fixedHeightPaper}>
                  <Team store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <Attendance store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>
      
            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <AttendanceWeek store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>
            
            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <Revenue store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid> 
       
            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <RevenueWeek store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <PA store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>            
       
            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <PAWeek store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <ARPPU store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>            

            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <ARPPUWeek store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <RevPerSeller store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid>            
            
            <Grid item xs={12} md={6} lg={6}>
              <Paper className={fixedHeightPaper}>
                <RevPerSellerWeek store_id={sessionStorage.store_id}/>
              </Paper>
            </Grid> 

          </Grid>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
}
